exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-layout {\n  height: 100%;\n  background-color: #f8f8f8 !important;\n}\n.ant-layout-header {\n  background: white !important;\n}\n.ant-layout-content {\n  background-color: #f8f8f8;\n  margin: 0 5em 0 5em;\n}\n.ant-table-wrapper {\n  margin: 1em 2em 1em 2em !important;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n.ant-table-wrapper:hover {\n  -webkit-box-shadow: 0 1px 3px rgba(142, 68, 173, 0.6);\n          box-shadow: 0 1px 3px rgba(142, 68, 173, 0.6);\n}\n.ant-table-row {\n  padding: 16px 8px !important;\n}\n.headerLogo {\n  height: 70%;\n  width: auto;\n  -webkit-transform: translateY(10%);\n      -ms-transform: translateY(10%);\n          transform: translateY(10%);\n}\n.settingsButton {\n  float: right;\n  margin-top: 15px;\n}\n.ant-select-tree-dropdown {\n  height: 20vh;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js??ref--5-3!./src/styles/dashboard.less
// module id = 1218
// module chunks = 0